import styled from 'styled-components'
import { Th as ChakraTh, Td as ChakraTd } from '@chakra-ui/react'

export const Th = styled(ChakraTh)`
  text-align: center;
  color: #fff;
`

export const Td = styled(ChakraTd)`
  text-align: center;
`
